import * as React from "react"
import { cn } from "@lib/cn"

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "inline-flex items-center gap-0.5 text-small font-medium text-cloverhound-gray-800 dark:text-cloverhound-gray-50",
        "peer-disabled:cursor-not-allowed peer-disabled:opacity-60",
        className,
      )}
      {...props}
    >
      {children}
      {required && (
        <span className="text-cloverhound-red-500" aria-hidden="true">
          *
        </span>
      )}
    </label>
  ),
)
Label.displayName = "Label"
